export default __webpack_public_path__ + "images/7e9c489851ff9ec36097be779535d81f.png";